export enum Action {
    ADD = 'ADD',
    CON = 'CON',
    DEL = 'DEL',

    PENDING_STATIC = 'PENDING_STATIC'
}